<section class="section" style="padding-top: 10px !important;">
    <div class="container container-xs">
        <div class="row">
            <div class="col-xxl-10 offset-xxl-1 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-xs-12">
            </div>

            <div class="col-xxl-10 offset-xxl-1 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-xs-12 contburbu  animated fadeIn">
                <div class="caminodemigas">
                    <button type="button" class="btn btn-link" (click)="gotoInicio()">
                        <i class="fas fa-home"></i> Inicio
                    </button>
                </div>
                <div class="row" *ngIf="loading">
                    <div class="col-12">
                        <div class="alert alert-info text-center">
                            <h4 class="alert-heading">Cargando</h4>
                            <i class="fa fa-sync fa-spin fa-3x"></i>
                            <p class="mb-0">Espera por favor...</p>
                        </div>
                    </div>
                </div>

                <div class="advance-search">
                    <div class="row">
                        <div class="col-12 text-center w-100">
                            <div id="custom-search-input">
                                <div class="row">
                                    <div class="col">
                                        <h4 class="tit"><a type="button" class="btn btn-link" (click)="gotoInicio()"><i class="fas fa-arrow-left"></i></a>Resultados de búsqueda</h4>
                                        <div class="input-group">
                                            <input class="search-query form-control input-src busqueda_avanzada" placeholder="Buscar" type="search" [ngClass]="{'loading': loadingIncremental}" [spellcheck]="false" (ngModelChange)="searchIncremental($event)" [(ngModel)]="src" (focus)="onLocationFocus()"
                                                (blur)="onLocationBlur()" (keydown.ArrowUp)="onArrowUp()" (keydown.ArrowDown)="onArrowDown()" (keydown.enter)="onEnter(0)" (keydown.esc)="onEsc()">
                                            <span class="input-group-btn">
                                                <button class="btn btn-link" type="button" (click)="onEnter(0)"> <i class="fas fa-search"></i> </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="results" *ngIf="!!src && show">
                                <ul style="height: 500px;overflow-y: scroll;">
                                    <li *ngIf="data.length==0 && !errorBusqueda && !loading">No se han encontrado resultados.</li>
                                    <li *ngIf="errorBusqueda">No se han encontrado resultados.</li>
                                    <li #itemli [ngClass]="{'focus-background': focusElement == itemli.tabIndex}" *ngFor="let item of data; let i = index" tabIndex="{{i}}" (click)="onEnter(item.preguntaId)" style="display: grid;">
                                        <h4 class="tit_respuesta">
                                            <ngx-highlight-words [textToHighlight]="item.desPregunta" [searchWords]="strBusqueda" [sanitize]="removeDiacritics" highlightClassName="markpro" (click)="onEnter(item.preguntaId)">
                                            </ngx-highlight-words>
                                        </h4>
                                        <span class="ruta">
                                            <ngx-highlight-words [textToHighlight]="item.desBurbuja" [searchWords]="strBusqueda" [sanitize]="removeDiacritics" highlightClassName="markpro" (click)="onEnter(item.preguntaId)">
                                            </ngx-highlight-words> >
                                            <ngx-highlight-words [textToHighlight]="item.desTema" [searchWords]="strBusqueda" [sanitize]="removeDiacritics" highlightClassName="markpro" (click)="onEnter(item.preguntaId)">
                                            </ngx-highlight-words>
                                        </span>

                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="(loading==false) && (noBusco==true)">
                    <label><h3 style="margin-top: 5px;"><i class="fas fa-exclamation"></i> Para poder buscar tenes que ingresar mas de un caracter </h3></label>
                </div>
                <div *ngIf="loading==false && !resultado && noBusco==false">
                    <label><h3 style="margin-top: 5px;"><i class="fas fa-exclamation"></i> No encontramos resultados para tu búsqueda.</h3></label>
                </div>
                <h1 *ngIf="loading==false && resultado?.length>0" class="encontrados resul mt-3">
                    Encontramos {{cantidadRegistros}} resultados para tu búsqueda de: "{{terminoBusqueda}}"
                </h1>
                <div class="cont_resul" *ngFor="let item of resultado">
                    <div class="list-group-item list-group-item-action">
                        <h4 class="tit_respuesta">
                            <ngx-highlight-words [textToHighlight]="item.desPregunta" [searchWords]="strBusqueda" [sanitize]="removeDiacritics" highlightClassName="markpro" (click)="responderPregunta(item.preguntaId)">
                            </ngx-highlight-words>
                        </h4>
                        <div class="minicaminodemigas ruta">
                            <ngx-highlight-words [textToHighlight]="item.desBurbuja" [searchWords]="strBusqueda" [sanitize]="removeDiacritics" highlightClassName="markpro" (click)="gotoTemas(item.burbujaId,item.desBurbuja)">
                            </ngx-highlight-words>
                            <span> &nbsp;<i class="fas fa-chevron-right"></i> &nbsp;</span>
                            <ngx-highlight-words [textToHighlight]="item.desTema" [searchWords]="strBusqueda" [sanitize]="removeDiacritics" highlightClassName="markpro" (click)="gotoPreguntas(item.temaId)">
                            </ngx-highlight-words>
                        </div>
                    </div>
                </div>
                <br>
                <div class="ml-4" *ngIf="loading==false && resultado?.length>0">


                    <button (click)="cambiarPagina(-1)" type="button" class="btn btn-link" [disabled]="pagina<=1" class="paginacion_ant"><i class="fas fa-arrow-circle-left"></i> Anterior</button> &nbsp;
                    <div class="paginacion">
                        <label>Página {{pagina}} de {{cantidadPaginas}}&nbsp;&nbsp;&nbsp;</label>
                        <label>Resultados por página:</label>
                        <select [(ngModel)]="pgrSelectedValue" (change)="cambiarPager()">
                            <option *ngFor="let cant of pgrCantRegistros" [ngValue]="cant.valor">{{cant.texto}}</option>
                        </select>
                    </div>
                    <button (click)="cambiarPagina(1)" type="button" class="btn btn-link" [disabled]="pagina==cantidadPaginas" class="paginacion_sig">Siguiente <i class="fas fa-arrow-circle-right"></i></button>

                </div>

            </div>
            <div class="col-md-10 offset-md-1 col-lg-2 offset-lg-0">
                <div class="sidebar">
                    <!-- Search Widget -->
                    <div class="widget search p-0">
                    </div>
                    <div class="widget related-store">
                        <!-- Widget Header -->
                    </div>
                    <!-- Category Widget -->
                    <div class="widget category">
                        <!-- Widget Header -->
                    </div>
                    <!-- Store Widget -->
                </div>
            </div>
        </div>
    </div>
</section>